import { CommonModule } from "@angular/common";
import { NgModule } from "@angular/core";
import { FormsModule } from "@angular/forms";
import { AssigneesModule } from "@webapp/assignees/assignees.module";
import { FeatureTogglesModule } from "@webapp/feature-toggles/feature-toggles.module";
import { LocalizationModule } from "@webapp/localization/localization.module";
import { ViewHistoryServiceProvider } from "@webapp/navigation/providers/view-history.provider";
import { GlobalSearchComponent } from "@webapp/search/components/global-search/global-search.component";
import { InsightRedirectComponent } from "@webapp/search/components/insight-redirect/insight-redirect.component";
import { NoSearchItemsFoundComponent } from "@webapp/search/components/no-search-items-found/no-search-items-found.component";
import { SearchItemComponent } from "@webapp/search/components/search-item/search-item.component";
import { SearchResultsComponent } from "@webapp/search/components/search-results/search-results.component";
import { SearchRoutingModule } from "@webapp/search/search-routing.module";
import { GlobalSearchTrackingService } from "@webapp/search/services/global-search-tracking.service";
import { GlobalSearchMediatorService } from "@webapp/search/services/global-search.mediator.service";
import { SortByPipe } from "@webapp/shared/pipes/sort-by/sort-by.pipe";
import { UiButtonModule } from "@webapp/ui/button/button.module";
import { UiDividerModule } from "@webapp/ui/divider/divider.module";
import { UiDropdownModule } from "@webapp/ui/dropdown/dropdown.module";
import { UiIconModule } from "@webapp/ui/icon/icon.module";
import { UiMenuModule } from "@webapp/ui/menu/menu.module";
import { UiPaginationModule } from "@webapp/ui/pagination/pagination.module";
import { UiPopoverModule } from "@webapp/ui/popover/popover.module";
import { UiSkeletonModule } from "@webapp/ui/skeleton/skeleton.module";
import { UiTooltipModule } from "@webapp/ui/tooltip/tooltip.module";

@NgModule({
  declarations: [NoSearchItemsFoundComponent, GlobalSearchComponent, SearchResultsComponent, SearchItemComponent],
  exports: [GlobalSearchComponent],
  imports: [
    CommonModule,
    UiSkeletonModule,
    UiIconModule,
    LocalizationModule,
    UiTooltipModule,
    UiDropdownModule,
    FormsModule,
    UiMenuModule,
    UiDividerModule,
    SearchRoutingModule,
    FeatureTogglesModule,
    UiPaginationModule,
    UiButtonModule,
    UiPopoverModule,
    SortByPipe,
    AssigneesModule,
    InsightRedirectComponent,
  ],
  providers: [GlobalSearchMediatorService, ViewHistoryServiceProvider, GlobalSearchTrackingService],
})
export class SearchModule {}
